import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles((theme: Theme) => ({
  containerImplantation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 10px',
    borderRadius: '100px',
    color: '#311B92',
    backgroundColor: `${getRGBA('#311B92', 0.08)} !important`,
  },

  containerMovimentation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 10px',
    borderRadius: '100px',
    color: '#006064',
    backgroundColor: `${getRGBA('#006064', 0.08)} !important`,
  },

  containerQuotation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 10px',
    borderRadius: '100px',
    color: '#FF6D00',
    backgroundColor: `${getRGBA('#FF6D00', 0.08)} !important`,
  },

  status: {
    fontFamily: 'Nunito',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '22px',
  },
}))

export { useStyles }
